import s from './style.module.scss';
import { Display } from '@/components/Display/Display';
import { useState } from 'react';
// import choseImg from '@/assets/images/web/courseRecommend/chose.webp';
import moment from 'moment';
import GrtButton from '@/components/Web/GrtButton';
import { secondCheck } from '@/utils/Page/courseRecommend';
const getTime = (end_state, start_time, end_time) => {
    if (end_state === 2) {
        return '长期有效';
    }
    if (start_time && end_time) {
        return moment(start_time).format('YYYY-MM-DD HH:mm:ss') + ' 至 ' + moment(end_time).format('YYYY-MM-DD HH:mm:ss');
    }
    return null;
};
const MobileChoseCourse = (props) => {
    const [choseItem, setChoseItem] = useState({}); //当前选择的
    const { list, resource_id } = props;
    const onClick = async () => {
        let data = {
            resource_id,
            business_id: choseItem.business_id,
            template_id: choseItem.template_id
        };
        console.log(data, 'data');
        let res = await secondCheck(data);
        if (res) {
            window.choseCourseModal.destroy();
        }
    };
    return (
        <div className={s['chose-list-box']}>
            <div className={s['tip-text']}>该视频存在{list.length}个视频课下，请任选一个进行学习</div>
            <div className={s['chose-list-wrap']}>
                {list.map((ele, index) => {
                    return (
                        <div
                            key={index}
                            onClick={() => {
                                setChoseItem(ele);
                            }}
                            className={s['chose-item']}
                            data-active={choseItem.business_id === ele.business_id}
                        >
                            <Display show={choseItem.business_id === ele.business_id}>
                                {/* <img className={s['check-img']} src={choseImg} alt="" /> */}
                                <div className={s['check-img']}></div>
                            </Display>
                            <div className={s['catetory-wrap']}>
                                {ele?.category_list.map((item, idx) => {
                                    return (
                                        <span key={idx} data-type={ele.template_id} className={s['category']}>
                                            {item.name}
                                        </span>
                                    );
                                })}
                            </div>
                            <div className={s['title']}>{ele.title}</div>
                            <div className={s['time']}>{getTime(ele.end_state, ele.start_time, ele.end_time) || ''}</div>
                        </div>
                    );
                })}
            </div>
            <div style={{ textAlign: 'center' }}>
                <GrtButton disabled={!choseItem.business_id} onClick={onClick} style={{ width: 200, height: 40 }} type="primary">
                    确定
                </GrtButton>
            </div>
        </div>
    );
};

export default MobileChoseCourse;
